"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CSS = {
    saveShareAnchor: {
        display: 'flex',
        width: '70px',
        height: '70px',
        marginTop: '2.5%',
        marginLeft: '5%',
        marginRight: '5%',
    },
    buttonImage: {
        pointerEvents: 'none',
        display: 'flex',
        justifyContent: 'center',
        margin: 'auto',
        width: '40px',
        height: '40px',
    },
    buttonCloseAnchor: {
        width: '15px',
        height: '15px',
        margin: '4%',
        zIndex: 9999,
        top: 0,
        position: 'absolute',
    },
    previewElement: {
        height: 'auto',
        width: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: '#ccc',
        boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.5)',
        display: 'flex',
    },
    containerDiv: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: '0px',
        left: '0px',
        zIndex: 10000,
        backgroundColor: 'rgba(255,255,255,1)',
        fontFamily: 'sans-serif',
        color: 'rgba(255,255,255,1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    flexContainerDiv: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    buttonCloseImage: {
        pointerEvents: 'none',
        width: '15px',
        height: '15px',
    },
    buttonOpenFiles: {
        border: '2px solid black',
        textTransform: 'uppercase',
        padding: '10px',
        minWidth: '100px',
        color: 'black',
        display: 'inline - block',
        marginTop: '20px',
        textDecoration: 'none',
        borderRadius: '10px',
    },
    instructions: {
        color: 'black',
        marginBottom: '0',
        width: '100%',
        textAlign: 'center',
        display: 'none',
    },
};
exports.default = CSS;
//# sourceMappingURL=styles.js.map